import Vue from "vue";
import VueRouter  from "vue-router";
import Home from "@/view/home.vue";
import Solution from "@/view/solution/index.vue";
import SolutionList from "@/view/solution/solution.vue";
import SolutionDetails from "@/view/solution/SolutionDetails.vue";
import news from "@/view/news/index.vue";
import newsList from "@/view/news/news.vue";
import newsDetails from "@/view/news/newsDetails.vue";
import service from "@/view/service/service.vue";
import aboutUs from "@/view/aboutUs/index.vue";
import Product from "@/view/product/index.vue";
import productList from "@/view/product/product.vue";
import productDetails from "@/view/product/productDetails.vue";
import download from "@/view/download";
import seach from "@/view/seach";
Vue.use(VueRouter);
const routerPush = VueRouter.prototype.push;

// VueRouter.prototype.push = function(location) {
//   return routerPush.call(this, location).catch(err => {});
// };


export default new VueRouter ({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      meta: {
        name: "Home",
        title: "首页",
        isShow: true
      },
      component: () => import("@/view/home.vue")
    },
    {
      path: "/Solution",
      name: "SolutionList",
      meta: {
        name: "Solution",
        title: "解决方案",
        isShow: true
      },
      component: () => import("@/view/solution/index.vue"),
      children: [
        {
          path: "/SolutionDetails",
          name: "SolutionDetails",
          meta: {
            name: "Solution",
            title: "Solution"
          },
          component: () => import("@/view/solution/SolutionDetails.vue")
        },
        {
          path: "/SolutionList",
          name: "SolutionList",
          meta: {
            name: "Solution",
            title: "Solution"
          },
          component: () => import("@/view/solution/solution.vue")
        }
      ]
    },
    {
      path: "/Product",
      name: "productList",
      meta: {
        name: "Product",
        title: "产品中心",
        isShow: true
      },
      component: () => import("@/view/product/index.vue"),
      children: [
        {
          path: "/productDetails",
          name: "productDetails",
          meta: {
            name: "Product",
            title: "Product"
          },
          component: () => import("@/view/product/productDetails.vue")
        },
        {
          path: "/productList",
          name: "productList",
          meta: {
            name: "Product",
            title: "Product",
            keepAlive: true //true为需要缓存，false为不需要缓存（不需要的也可以不加）
          },
          component: () => import("@/view/product/product.vue")
        }
      ]
    },
    {
      path: "/service",
      name: "Service support",
      meta: {
        name: "Service support",
        title: "服务中心",
        isShow: true
      },
      component: () => import("@/view/service/service.vue")
    },
    // {
    //   path: "/news",
    //   name: "newsList",
    //   meta: {
    //     name: "News",
    //     isShow: true,
    //     title: "新闻动态"
    //   },
    //   component: () => import("@/view/news/index.vue"),
    //   children: [
    //     {
    //       path: "/newsDetails",
    //       name: "newsDetails",
    //       meta: {
    //         name: "News",
    //         title: "News"
    //       },
    //       component: () => import("@/view/news/newsDetails.vue")
    //     },
    //     {
    //       path: "/newsList",
    //       name: "newsList",
    //       meta: {
    //         name: "News",
    //         title: "News"
    //       },
    //       component: () => import("@/view/news/news.vue")
    //     }
    //   ]
    // },
    {
      path: "/aboutUs",
      name: "About us",
      meta: {
        name: "About us",
        title: "关于我们",
        isShow: true
      },
      component: () => import("@/view/aboutUs/index.vue")
    },
    {
      path: "/download",
      name: "download",
      meta: {
        name: "download",
        title: "download",
        isShow: false
      },
      component: () => import("@/view/download.vue")
    },
    {
      path: "/seach",
      name: "seach",
      meta: {
        name: "seach",
        title: "搜索",
        isShow: false
      },
      component: () => import("@/view/seach.vue")
    },
    {
      path: "/f5",
      name: "f5",
      meta: {
        name: "f5",
        title: "f5",
        isShow: false
      },
      component: () => import("@/view/f5.vue")
    }
  ]
});




// WEBPACK FOOTER //
// ./src/router/index.js